var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('a',{attrs:{"target":"_blank","href":"https://sybill.io/ "}},[_c('logo',{staticClass:"logo"})],1),_vm._v(" "),_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }